// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + "7f542d487dd28c473c3f" + ".js";
};